<ejs-dialog
  #dialog
  [visible]="false"
  [header]="title"
  [width]="width"
  [height]="height"
  [isModal]="true"
  [showCloseIcon]="true"
  [closeOnEscape]="!isOperation"
  [cssClass]="'smo-form-dialog' + (cssClass ? ' ' + cssClass : '')"
  [animationSettings]="{ effect: 'None', duration: 0, delay: 0 }"
  (beforeOpen)="onBeforeOpen()"
  (open)="onOpen()"
  (beforeClose)="onBeforeClose($event)"
  (close)="onClose()"
>
  <ng-template #content>
    <div class="dialog-content">
      <ng-content></ng-content>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <div class="dialog-footer">
      <button
        ejs-button
        type="button"
        cssClass="e-outline"
        [disabled]="isOperation"
        (click)="onCancel()"
      >
        {{ cancelButtonText }}
      </button>
      <button
        *ngIf="saveVisible"
        ejs-button
        type="button"
        cssClass="e-success"
        [disabled]="isOperation || saveDisabled"
        (click)="onSave()"
      >
        {{ saveButtonText }}
      </button>
    </div>
  </ng-template>
</ejs-dialog>
